<div class="swapSection" [ngClass]="{ 'mt-1': !isModal }">
  <div class="tab-container gap-2 mb-3" *ngIf="isModal">
    <button class="btn btn-tertiary" [ngClass]="{ selected: !isWert && activeToken.symbol === 'ETH' }" (click)="changeTab('ETH', 'ETH')">
      <img src="/assets/images/svg-icons/ETH.svg" height="25" alt="ETH" />
      <span class="px-2">ETH</span>
    </button>

    <button class="btn btn-tertiary" [ngClass]="{ selected: !isWert && activeToken.symbol === 'USDT' }" (click)="changeTab('ETH', 'USDT')">
      <img src="/assets/images/svg-icons/usdt.svg" height="25" alt="USDT" />
      <span class="ps-2">USDT</span>
    </button>

    <button class="btn btn-tertiary" [ngClass]="{ selected: !isWert && activeToken.symbol === 'USDC' }" (click)="changeTab('ETH', 'USDC')">
      <img src="/assets/images/svg-icons/usdc.svg" height="25" alt="USDC" />
      <span class="ps-2">USDC</span>
    </button>

    <button class="btn btn-tertiary" [ngClass]="{ selected: !isNative && isWert }" (click)="cardMode()">
      <img src="/assets/images/svg-icons/card.svg" height="26" alt="" class="float-start" />
      <span class="fw-semibold">{{ 'widget.card' | translate }}</span>
    </button>
  </div>

  <div class="text-center pb-2 font-16" *ngIf="walletAddress && isModal && !isWert">
    <div class="ms-2 fw-semibold dashTitle text-light">{{ activeToken.symbol }} {{ 'balance' | translate }} {{ convertNum(activeToken.tokenBalance, 4) }}</div>
  </div>

  <!-- ====== not started ====== -->

  <div class="body-section mt-2" *ngIf="status === SwapStatus.not_started" [ngClass]="{ 'mt-0': isModal }">
    <div class="row">
      <div class="col-7 col-xl-7 pe-xl-2" [class.col-7]="!isWert && !isModal" [class.col-xl-12]="isWert || isModal">
        <div class="d-flex align-items-center justify-content-between mb-1">
          <label class="d-block font-12 text-white fw-bold">{{ 'widget.pay_with' | translate: { tokenName: isWert ? 'USD' : activeToken.symbol } }} </label>
          <div class="text-white fw-bold cursor-pointer font-12 text-uppercase" (click)="max()" *ngIf="!isWert">{{ 'widget.max' | translate }}</div>
        </div>

        <div class="amountField d-flex align-items-start">
          <input #swapIn type="text" appTwoDigitDecimalNumber [noDecimal]="isNative ? 10 : 6" class="form-control text-truncate" placeholder="0" [(ngModel)]="swapToken" (ngModelChange)="swapTokenUpdate.next($event)" />
        </div>
      </div>

      <div class="col-5 col-xl-5 ps-3g-2 pe-xl-2 amountTypeDrp align-self-end mb-0 ms-0" *ngIf="!isWert && !isModal">
        <div class="mb-1 text-white text-end" *ngIf="!isWert">
          <p class="font-12 mb-0 text-white fw-bold">{{ 'widget.balance' | translate }} = {{ convertNum(activeToken.tokenBalance, 4) }}</p>
        </div>
        <div class="align-self-end">
          <div class="dropdown eth-dropdown" dropdown>
            <button class="btn mx-0 toggle-btn w-100" dropdownToggle #dropDownBtn>
              <div class="dropdown-item d-flex align-items-center justify-content-center px-auto">
                <img [src]="activeToken.image" alt="ETH" class="eth-logo" />
                <span class="eth-name text-white mx-2 fs-6">{{ activeToken.symbol }}</span>
                <span class="arrow-down">
                  <img src="/assets/images/svg-icons/down-arrow.svg" alt="down_arrow" class="down-arrow" />
                </span>
              </div>
            </button>
            <div class="dropdown-menu dropdown-menu-right" *dropdownMenu (click)="$event.stopPropagation()">
              <div class="text-center font-15 mt-3 text-white">{{ 'widget.choose_method' | translate }}</div>
              <div class="tabs gap-2">
                <button class="btn btn-secondary" (click)="setTab('ALL', $event, true)" [class.active]="selectedTab === 'ALL'">
                  <span>All</span>
                </button>
                <button class="btn btn-secondary" (click)="setTab('ETH', $event, true)" [class.active]="selectedTab === 'ETH'">
                  <div class="d-flex align-items-center">
                    <img src="/assets/images/svg-icons/ETH.svg" alt="ETH" class="eth-logo me-1" />
                    <span>ETH</span>
                  </div>
                </button>
                <button class="btn btn-secondary" (click)="setTab('BNB', $event, true)" [class.active]="selectedTab === 'BNB'">
                  <div class="d-flex align-items-center">
                    <img src="/assets/images/svg-icons/BNB.svg" alt="BNB" class="eth-logo me-1" />
                    <span>BSC</span>
                  </div>
                </button>
              </div>

              <div class="itemHolder">
                <div
                  class="d-flex justify-content-between tab-cont-wrap"
                  *ngFor="let item of tokenFilteredList; let i = index"
                  [ngClass]="{ 'active-tab': activeToken.symbol === item.symbol && activeToken.category === item.category, 'no-bal': item.tokenBalance == 0, 'cursor-pointer': item.tokenBalance > 0 }"
                  (click)="item.tokenBalance > 0 ? setActiveTab(item, item.category) : $event.stopPropagation()"
                >
                  <div class="d-flex">
                    <img [src]="item.image" alt="token-icon" class="drop-logo" />
                    <div class="pt-2 ms-2 font-14">
                      <p class="mb-0">{{ item.name }}</p>
                      <p class="mb-2 dark-glow font-14">{{ item.symbol }}</p>
                    </div>
                  </div>
                  <div class="pt-2 font-14" [class.d-none]="!walletAddress">
                    <p class="mb-0 me-0 text-end">~${{ convertNum(item.tokenUsdVal, 4) }}</p>
                    <p class="mb-2 me-0 text-end dark-glow font-14">{{ convertNum(item.tokenBalance, 4) }}</p>
                  </div>
                </div>
              </div>

              <p class="text-center my-2 font-13 text-white dashTitle">Or</p>
              <button type="button" class="btn btn-secondary w-50 mb-3 mx-auto" (click)="isWert = true">{{ 'widget.buy_with_card' | translate }}</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-12 pe-xl-2 mt-2 mt-xl-2">
        <div class="d-flex align-items-center justify-content-between mb-1">
          <label class="d-block font-12 text-truncate text-white fw-bold">{{ 'widget.amount_in' | translate: { cryptoName } }}</label>
          <label class="d-block d-3g-none d-xl-block font-12 text-truncate text-white fw-bold">1 {{ cryptoName }} = ${{ salePrice }}</label>
        </div>

        <div class="amountField">
          <input type="text" appTwoDigitDecimalNumber [noDecimal]="0" class="form-control text-truncate" [(ngModel)]="baseToken" min="minAmount" (ngModelChange)="baseTokenUpdate.next($event)" pattern="\d*" placeholder="0" />
          <div class="amountType">
            <img height="28" width="28" src="./assets/images/svg-icons/token.svg" alt="Logo" />
          </div>
        </div>
      </div>
    </div>

    <!-- ----- low balance info and error section ----- -->

    <div class="w-100 text-center">
      <div class="lowBalance m-2 mb-0 text-white font-12" *ngIf="!isLowBalance && !isWert && walletAddress">{{ 'widget.gas_fees' | translate: { gasFees, modeName: activeToken.category } }}</div>
      <div class="lowBalance m-2 mb-0 text-white font-12" *ngIf="isNative && isLowBalance && !isWert && walletAddress">{{ 'widget.low_gas_fees' | translate: { modeName: activeToken.category } }}</div>
      <div class="lowBalance m-2 mb-0 text-white font-12" *ngIf="!isNative && isLowBalance && !isWert && walletAddress">{{ lowGas ? ('widget.low_gas_fees' | translate: { modeName: activeToken.category }) : ('widget.low_usdt' | translate: { modeName: activeToken.symbol }) }}</div>

      <div class="text-center mt-2 w-100 text-warning font-12" *ngIf="baseToken && baseToken < minAmount && !isWert && walletAddress">
        {{ 'widget.min_crypto' | translate: { minAmount, cryptoName } }}
      </div>

      <div class="text-center mt-2 w-100 text-warning font-12" *ngIf="baseToken && baseToken >= minAmount && isLowBalance && !isWert && walletAddress">
        {{ 'widget.swap_error' | translate: { gasFees, modeName: activeToken.category, tokenName: activeToken.symbol } }}
      </div>
    </div>

    <div class="d-flex flex-column flex-3g-row flex-xl-column align-items-center align-items-stretch gap-2">
      <button type="button" class="btn btn-secondary btn-yellow mt-2 w-100 w-3g-50 w-xl-100" *ngIf="activeToken.category == 'ETH'" [disabled]="(isLowBalance && !isWert) || !swapToken || swapToken == 0" (click)="confirm(true)">
        {{ 'staking.buy_stake_for' | translate }} {{ stakeData.apy }}% {{ 'staking.rewards' | translate }}
      </button>

      <button type="button" class="btn btn-primary buy-btn btn-orange mx-auto mt-2 w-100 w-3g-50 w-xl-100" *ngIf="!isModal" [disabled]="(isLowBalance && !isWert) || !swapToken || swapToken == 0" (click)="confirm()">{{ 'widget.buy_now' | translate }}</button>
    </div>

    <p class="change-text text-white fw-bold text-center mt-2" *ngIf="!isModal">
      {{ (isWert ? 'widget.pay_with_crypto_instead' : 'widget.pay_with_card_instead') | translate }}
      <span (click)="isWert = !isWert; max()" class="clickable">{{ 'widget.click_here' | translate }}</span>
    </p>

    <p class="font-14 text-center my-2" *ngIf="!isWert">
      <a (click)="openEthBuyWidget()" *ngIf="activeToken.category == 'ETH' && walletAddress" class="text-decoration-underline cursor-pointer text-yellow">
        {{ 'widget.not_enough_eth' | translate }}
      </a>

      <a *ngIf="activeToken.category == 'BNB' && walletAddress" class="text-decoration-underline cursor-pointer text-yellow" (click)="openEthBuyWidget(true)">
        {{ 'widget.not_enough_bnb' | translate }}
      </a>
    </p>
  </div>

  <!-- ====== show loader ====== -->

  <div class="body-section mt-1 text-center" *ngIf="status === SwapStatus.in_progess" [ngClass]="{ 'mt-0': isModal }">
    <img src="./assets/images/svg-icons/token.svg" alt="loading" class="statusIcon loading" />
    <div class="fw-normal fw-bold font-16 px-2 my-1 text-uppercase text-light text-center">{{ 'widget.transaction_in_progress' | translate }}</div>
    <p class="fs-7 mb-1 text-light" *ngIf="!isStake">{{ 'widget.transction_info' | translate: { baseToken, cryptoName } }}</p>
    <p class="fs-7 mb-1 text-light" *ngIf="isStake">{{ 'staking.transction_info_stake' | translate: { baseToken } }}</p>
  </div>

  <!-- ====== show confirm ====== -->

  <div class="body-section mt-1 text-center" *ngIf="status === SwapStatus.confirm_pending" [ngClass]="{ 'mt-0': isModal }">
    <img src="./assets/images/svg-icons/token.svg" alt="loading" class="statusIcon loading" />
    <div class="fw-semibold fs-6 my-1 text-uppercase text-center text-secondary">{{ 'confirm' | translate }}</div>
    <p class="fs-7 mb-1 text-light" *ngIf="!isStake">{{ 'widget.waiting_confirm' | translate: { cryptoName, tokenName } }}</p>
    <p class="fs-7 mb-1 text-light" *ngIf="isStake">{{ 'staking.waiting_confirm_stake' | translate }}</p>
    <p class="fs-7 mb-1 text-light" *ngIf="isStake">{{ 'staking.waiting_confirm_stake_2' | translate }}</p>
  </div>

  <!-- ====== show pending ====== -->

  <div class="body-section mt-1 text-center" *ngIf="status === SwapStatus.approval_pending" [ngClass]="{ 'mt-0': isModal }">
    <img src="./assets/images/svg-icons/token.svg" alt="loading" class="statusIcon loading" />
    <div class="fw-semibold fs-6 my-1 text-uppercase text-secondary">{{ 'widget.authorise' | translate }}</div>
    <p class="fs-7 mb-1 text-light">{{ 'widget.waiting_approve' | translate: { cryptoName, tokenName: activeToken.symbol } }}</p>
  </div>

  <!-- ====== show pending wert ====== -->

  <div class="body-section mt-1 text-center" *ngIf="status === SwapStatus.wert_inprogress" [ngClass]="{ 'mt-0': isModal }">
    <img src="./assets/images/svg-icons/token.svg" alt="loading" class="statusIcon loading" />
    <div class="fw-semibold fs-6 my-1 text-uppercase text-secondary">
      {{ 'widget.transaction_in_progress' | translate }}
    </div>
    <p class="fs-7 mb-1 text-light">{{ 'widget.wert_pending' | translate }}</p>
    <button (click)="startAgain()" class="btn btn-primary w-100 fs-8 text-uppercase">
      {{ 'widget.continue' | translate }}
    </button>
  </div>

  <!-- ====== show success/completed ====== -->

  <div class="body-section mt-1 text-center" *ngIf="status === SwapStatus.complete" [ngClass]="{ 'mt-0': isModal }">
    <img src="./assets/images/popup-icons/success.svg" alt="complete" class="statusIcon" />
    <div class="fw-semibold fs-6 my-1 text-uppercase text-success text-center">{{ 'widget.transaction_success' | translate }}</div>
    <p class="fs-7 mb-1 text-light mb-lg-4" *ngIf="isStake">{{ 'staking.transction_info_stake_success' | translate: { baseToken } }}</p>
    <p class="fs-7 mb-1 text-light mb-lg-4" *ngIf="!isStake">{{ 'widget.transction_info' | translate: { baseToken, cryptoName } }}</p>

    <div class="d-flex align-items-center justify-content-center" *ngIf="modeName == 'ETH' && !isModal && !isStake">
      <button (click)="stakeNow()" class="btn btn-md mb-2 btn-primary w-100 fs-7 text-uppercase">{{ 'widget.stake_now' | translate }}</button>
    </div>
    <div class="d-flex align-items-center justify-content-center gap-2">
      <button (click)="viewUrl()" class="btn btn-primary w-50 fs-8 text-uppercase">{{ 'widget.view_transaction' | translate }}</button>
      <button (click)="startAgain()" class="btn btn-primary w-50 fs-8 text-uppercase">{{ 'widget.start_again' | translate }}</button>
    </div>
  </div>

  <!-- ====== show failed ====== -->

  <div class="body-section mt-1 text-center" *ngIf="status === SwapStatus.failed" [ngClass]="{ 'mt-0': isModal }">
    <img src="./assets/images/popup-icons/warning.svg" alt="failed" class="statusIcon" />
    <div class="fw-semibold fs-6 my-1 text-uppercase text-danger text-center">{{ 'widget.transaction_failed' | translate }}</div>
    <p class="fs-7 mb-1 mb-lg-4 text-danger">{{ 'widget.view_transaction_info' | translate }}</p>
    <div class="d-flex align-items-center justify-content-center gap-2">
      <button (click)="viewUrl()" class="btn btn-primary w-50 fs-8 text-uppercase">{{ 'widget.view_transaction' | translate }}</button>
      <button (click)="startAgain()" class="btn btn-primary w-50 fs-8 text-uppercase">{{ 'widget.start_again' | translate }}</button>
    </div>
  </div>

  <!-- ====== show rejected ====== -->

  <div class="body-section mt-1 text-center" *ngIf="status === SwapStatus.rejected" [ngClass]="{ 'mt-0': isModal }">
    <img src="./assets/images/popup-icons/warning.svg" alt="failed" class="statusIcon" />
    <div class="fw-semibold fs-6 text-uppercase text-danger my-1 text-center">{{ 'widget.transaction_rejected' | translate }}</div>
    <div class="d-flex align-items-center justify-content-center gap-2 mt-3">
      <button (click)="startAgain()" class="btn btn-primary w-100 fs-7 bg-secondary text-primary text-uppercase">{{ 'widget.start_again' | translate }}</button>
    </div>
  </div>
</div>
